/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "target",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes",
                    },
                ],
                internalType: "struct Multicall.Call[]",
                name: "calls",
                type: "tuple[]",
            },
        ],
        name: "aggregate",
        outputs: [
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
            {
                internalType: "bytes[]",
                name: "returnData",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506103a9806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063252dba4214610030575b600080fd5b61004761003e366004610105565b60006060915091565b60405161005592919061029d565b60405180910390f35b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6040805190810167ffffffffffffffff811182821017156100b0576100b061005e565b60405290565b604051601f82017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe016810167ffffffffffffffff811182821017156100fd576100fd61005e565b604052919050565b6000602080838503121561011857600080fd5b823567ffffffffffffffff8082111561013057600080fd5b818501915085601f83011261014457600080fd5b8135818111156101565761015661005e565b8060051b6101658582016100b6565b918252838101850191858101908984111561017f57600080fd5b86860192505b838310156102905782358581111561019d5760008081fd5b860160407fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0828d0381018213156101d45760008081fd5b6101dc61008d565b8a84013573ffffffffffffffffffffffffffffffffffffffff811681146102035760008081fd5b815283830135898111156102175760008081fd5b8085019450508d603f85011261022d5760008081fd5b8a840135898111156102415761024161005e565b6102518c84601f840116016100b6565b92508083528e848287010111156102685760008081fd5b808486018d85013760009083018c0152808b0191909152845250509186019190860190610185565b9998505050505050505050565b600060408201848352602060408185015281855180845260608601915060608160051b87010193508287016000805b83811015610364577fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffa089880301855282518051808952835b8181101561031f578281018901518a82018a01528801610304565b508881018801849052601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0169097018601965093850193918501916001016102cc565b5094999850505050505050505056fea2646970667358221220d43711fa719e90fe5f5b604105888cf546d89929085799ca6e176072822f319564736f6c63430008100033";
export class Multicall__factory extends ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
Multicall__factory.bytecode = _bytecode;
Multicall__factory.abi = _abi;
